import { render, staticRenderFns } from "./voted.vue?vue&type=template&id=79777db9&scoped=true&"
import script from "./voted.vue?vue&type=script&lang=js&"
export * from "./voted.vue?vue&type=script&lang=js&"
import style0 from "./voted.vue?vue&type=style&index=0&id=79777db9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79777db9",
  null
  
)

export default component.exports